import { FC } from 'react';
import { Checkbox } from '@mui/material';
import { withStyles } from '@material-ui/core';
import { IBloodPressureReading } from '~/services/api/readings/types';
import { BloodPressureReadingPositionType } from '~/services/api/enums';

import StandingIcon from '../icons/Standing.svg';
import SittingIcon from '../icons/Sitting.svg';
import LayingIcon from '../icons/Laying.svg';
import MedicationNotTakenIcon from '../icons/MedicationNotTaken.svg';

import styles from './BloodPressureTooltip.module.scss';
import { IBloodPressureReadingUpdate } from '~/services/api/bloodPressureReadings/types';

const StyledCheckbox = withStyles({
  root: {
    padding: 2,
  },
})(Checkbox);

interface IProps {
  reading: IBloodPressureReading;
  onUpdate: (data: IBloodPressureReadingUpdate) => void;
}

const BloodPressureTooltip: FC<IProps> = ({ reading, onUpdate }) => {
  const positionOptions = [
    { type: BloodPressureReadingPositionType.Standing, icon: StandingIcon, label: 'Standing' },
    { type: BloodPressureReadingPositionType.Sitting, icon: SittingIcon, label: 'Sitting' },
    { type: BloodPressureReadingPositionType.Laying, icon: LayingIcon, label: 'Laying' },
  ];

  const handlePositionChange = (newPosition: BloodPressureReadingPositionType) => {
    const payload: IBloodPressureReadingUpdate = {
      id: reading.id,
      isMedicationNotTaken: reading.isMedicationNotTaken,
      positionTypeId: reading.positionTypeId === newPosition ? null : newPosition,
    };

    onUpdate(payload);
  };

  const handleMedicationChange = (event: any, data: boolean) => {
    const payload: IBloodPressureReadingUpdate = {
      id: reading.id,
      positionTypeId: reading.positionTypeId,
      isMedicationNotTaken: data,
    };

    onUpdate(payload);
  };

  return (
    <div className={styles.tooltipContainer}>
      <div className={styles.positionSection}>
        <h3 className={styles.title}>Body Position</h3>

        <div className={styles.optionsRow}>
          {positionOptions.map(option => (
            <div key={option.type} className={styles.option}>
              <img src={option.icon} alt={option.label} />
              <StyledCheckbox
                checked={reading.positionTypeId === option.type}
                onChange={() => handlePositionChange(option.type)}
                size="small"
              />
            </div>
          ))}
        </div>
      </div>

      <div className={styles.medicationSection}>
        <h3 className={styles.title}>Medication</h3>
        <div className={styles.optionsRow}>
          <div className={styles.option}>
            <img src={MedicationNotTakenIcon} alt="" />

            <StyledCheckbox
              checked={reading.isMedicationNotTaken}
              size="small"
              onChange={handleMedicationChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BloodPressureTooltip;
